import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";

/**✅ add branch Department Thunk **/
export const generateQrCodeThunk = createAsyncThunk(
    "qrCode/generateQrCodeThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_QRCODE, payload);
            const { message, statusCode } = response.data;
            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }
            return rejectWithValue(message || "QR Codes are failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "QR Codes are failed"
            );
        }
    }
);

/**✅ qrCode Thunk */
export const getQrCodeThunk = createAsyncThunk(
    "qrCode/getQrCodeThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getQrCode") {
            if (state.qrCode?.qrCodes?.length > 0) {
                return state.qrCode.qrCodes;
            }
        }

        try {
            const response = await api.post(API_ROUTES.QR_CODES, {
                employee_id: user?.user_id,
            });


            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch QR Codes");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

export const getQRIndividualThunk = createAsyncThunk(
    "qrCode/getIndividualDataThunk",
    async (payload = {}, { rejectWithValue }) => {

        try {
            const response = await api.post(API_ROUTES.GET_INDIVIDUALDATA, payload
            );


            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch individual data");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);
